
import React from 'react';
import './QuestionCard.css';

export const QuestionCard = ({ title, description, icon, isSelected, onSelect }) => {
  const cardClassName = `question-card ${isSelected ? 'selected' : ''}`;

  return (
    <div className={cardClassName} onClick={onSelect}>
      <div className="card-icon">{icon}</div>
      {/* Add this new div */}
      <div className="card-text-content">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
};